import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
  colors: {
    brand: {
      50: "#F0F4F8",
      100: "#D9E2EC",
      200: "#BCCCDC",
      300: "#9FB3C8",
      400: "#627D98",
      500: "#334E68",
      600: "#243B53",
      700: "#162237", // Primary Deep Navy
      800: "#0F1A2C",
      900: "#080F1C",
    },
    gold: {
      50: "#FFFDF0",
      100: "#FEF9C3",
      200: "#FEF08A",
      300: "#FDE047",
      400: "#FACC15",
      500: "#EAB308",
      600: "#CA8A04",
      700: "#A16207",
      800: "#854D0E",
      900: "#713F12",
    },
    accent: {
      50: "#EFF6FF",
      100: "#DBEAFE",
      200: "#BFDBFE",
      300: "#93C5FD",
      400: "#60A5FA",
      500: "#3B82F6",
      600: "#2563EB",
      700: "#1D4ED8",
      800: "#1E40AF",
      900: "#1E3A8A",
    },
    surface: {
      bg: "#F8FAFC",
      card: "#FFFFFF",
      border: "#E2E8F0",
      subtle: "#F1F5F9",
    },
  },
  fonts: {
    heading: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  shadows: {
    card: "0 2px 8px -1px rgba(15, 23, 42, 0.06), 0 1px 4px -1px rgba(15, 23, 42, 0.04)",
    cardHover: "0 14px 28px -4px rgba(15, 23, 42, 0.12), 0 6px 12px -2px rgba(15, 23, 42, 0.06)",
    elevated: "0 20px 25px -5px rgba(15, 23, 42, 0.1), 0 8px 10px -6px rgba(15, 23, 42, 0.04)",
    glowGold: "0 0 20px rgba(234, 179, 8, 0.25)",
    glowBlue: "0 0 20px rgba(37, 99, 235, 0.25)",
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "600",
        borderRadius: "8px",
        transition: "all 0.2s ease-in-out",
      },
      variants: {
        primary: {
          bg: "brand.700",
          color: "white",
          _hover: {
            bg: "brand.600",
            transform: "translateY(-1px)",
            boxShadow: "md",
          },
          _active: {
            bg: "brand.800",
            transform: "translateY(0)",
          },
        },
        gold: {
          bg: "gold.500",
          color: "brand.900",
          fontWeight: "700",
          _hover: {
            bg: "gold.400",
            transform: "translateY(-1px)",
            boxShadow: "0 4px 12px rgba(234, 179, 8, 0.35)",
          },
        },
        buyNow: {
          bg: "linear-gradient(135deg, #FF6B00 0%, #EA580C 100%)",
          color: "white",
          fontWeight: "700",
          _hover: {
            filter: "brightness(1.08)",
            transform: "translateY(-1px)",
            boxShadow: "0 4px 14px rgba(234, 88, 12, 0.35)",
          },
        },
      },
    },
    Card: {
      baseStyle: {
        container: {
          borderRadius: "12px",
          border: "1px solid",
          borderColor: "surface.border",
          bg: "surface.card",
          transition: "all 0.25s ease-in-out",
        },
      },
    },
  },
});

export default theme;
